import { API, classApi, paymentUpdate, reportAPI } from '@/api'
import { IPaymentReportFilters } from '../components/Filters/Filters'
import { status, type } from './types'

interface IPaymentReportFiltersForExel {
  startDate?: string
  endDate?: string
  courseId: 'all' | string
  classId: 'all' | string
  status: status
  type: type
  isShowZeroPayments?: boolean
}

export const updatePaymentStatus = async (): Promise<boolean> => {
  try {
    const res = await paymentUpdate.update()
    return res?.data.status === 'success'
  } catch (error) {
    console.error('Ошибка обновления:', error)
    return false
  }
}

export const removePayment = async (id: number): Promise<boolean> => {
  try {
    const res = await reportAPI.payments.paymentsRemove(id)
    return res?.data.status === 'success'
  } catch (error) {
    console.error('Ошибка удаления платежа:', error)
    return false
  }
}

export const getClassesIndex = async (): Promise<IClass[]> => {
  try {
    const res = await classApi.index({ expand: ['supervisor'] })
    return res?.data.data ?? []
  } catch (error) {
    console.error('Ошибка получения классов:', error)
    return []
  }
}

export const downloadPaymentsReport = async (
  filters: IPaymentReportFilters,
): Promise<boolean> => {
  try {
    const params: IPaymentReportFiltersForExel = {
      courseId: filters.courseId,
      classId: filters.classId,
      status: filters.status,
      type: filters.type,
    }

    if (filters?.startDate) {
      params.startDate = filters.startDate
    }
    if (filters?.endDate) {
      params.endDate = filters.endDate
    }

    const res = await API.get('reports/payments-to-excel', {
      responseType: 'blob',
      params,
    })

    if (res?.data) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Payments.xlsx') 
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      return true
    }
    return false
  } catch (error) {
    console.error('Ошибка скачивания отчета:', error)
    return false
  }
}
